"use client";

import * as React from "react";

import { createSVGIcon } from "./util";

/**
 * TODO (jfangrad): Track and determine if used and where
 * @trackcomponent
 */
export const ClockTruck = createSVGIcon(
  <>
    <path
      d="M5.31689 15.7667C5.31689 16.0938 5.44684 16.4075 5.67813 16.6388C5.90943 16.8701 6.22313 17 6.55023 17C6.87734 17 7.19104 16.8701 7.42234 16.6388C7.65363 16.4075 7.78357 16.0938 7.78357 15.7667C7.78357 15.4396 7.65363 15.1259 7.42234 14.8946C7.19104 14.6633 6.87734 14.5333 6.55023 14.5333C6.22313 14.5333 5.90943 14.6633 5.67813 14.8946C5.44684 15.1259 5.31689 15.4396 5.31689 15.7667V15.7667Z"
      stroke="currentColor"
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 15.7667C13.334 16.0938 13.4639 16.4075 13.6952 16.6388C13.9265 16.8701 14.2402 17 14.5673 17C14.8944 17 15.2081 16.8701 15.4394 16.6388C15.6707 16.4075 15.8007 16.0938 15.8007 15.7667C15.8007 15.4396 15.6707 15.1259 15.4394 14.8946C15.2081 14.6633 14.8944 14.5333 14.5673 14.5333C14.2402 14.5333 13.9265 14.6633 13.6952 14.8946C13.4639 15.1259 13.334 15.4396 13.334 15.7667Z"
      stroke="currentColor"
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8667 5.93201C10.8665 5.14557 10.6783 4.37059 10.3177 3.67167C9.95719 2.97275 9.43479 2.37015 8.79407 1.91412C8.15336 1.45808 7.41291 1.16184 6.63446 1.05007C5.856 0.93831 5.06211 1.01427 4.31898 1.27162C3.57584 1.52897 2.905 1.96026 2.36239 2.52951C1.81977 3.09876 1.42112 3.78949 1.19965 4.5441C0.978187 5.29871 0.940336 6.09532 1.08925 6.86753C1.23817 7.63974 1.56954 8.36515 2.05574 8.98329"
      stroke="currentColor"
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.93311 5.93201L7.78311 4.082"
      stroke="currentColor"
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.78351 15.7667H8.40018V10.8333H6.55017C5.89597 10.8333 5.26856 11.0932 4.80597 11.5558C4.34338 12.0184 4.0835 12.6458 4.0835 13.3V15.7667H5.31684"
      stroke="currentColor"
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8004 15.7666H17.0338V9.59995C17.0338 9.27284 16.9038 8.95914 16.6725 8.72784C16.4412 8.49655 16.1275 8.36661 15.8004 8.36661H9.63373C9.30663 8.36661 8.99292 8.49655 8.76163 8.72784C8.53033 8.95914 8.40039 9.27284 8.40039 9.59995V15.7666H13.3337"
      stroke="currentColor"
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "ClockTruck",
  {
    viewBox: "0 0 18 18",
    fill: "none",
  }
);
